/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'dashboard-analytics/visualizations/renderer/sequence/BaseTask'
], function(
	BaseTask
) {
	'use strict';

	var SetDataTask = BaseTask.extend({

		/**
		 * The Set Data task is performed as part of the renderSequence (after ResultDataReader has been fetched/postProcessed)
         * It sets the data to vipr widget
		 * @param renderContext - information collected by a particular call to render or reRender (such as the view, control, data etc).
		 * @returns a promise which resolves with the renderContext.
		 */
		process: function(renderContext) {
			if (this._isStepComplete(renderContext, 'setData')) {
				return Promise.resolve(renderContext);
			}

			return this.getRenderState().getCurrentContextData('visView')
				.whenSetDataReady(renderContext)
				.then((result) => {
					this._completeStep(renderContext, 'setData', result);
					return renderContext;
				})
				.catch(function(error) {
					this.showError('dwErrorRenderingVisualization');
					throw error;
				}.bind(this));
		}
	});

	return SetDataTask;
});
